__turbopack_context__.v({
  "btn": "styles-module-scss-module__xmH4Xa__btn",
  "root": "styles-module-scss-module__xmH4Xa__root",
  "title": "styles-module-scss-module__xmH4Xa__title",
});
